import { EmptyPayload } from "@/lib/events/types";

export type TourEngagedManagerEvents = {
  engaged: EmptyPayload;
};

export const TourEngagedManagerNamespace = "tourEngagedManager" as const;
